import type { IconData } from '@stacksjs/iconify-core'

export const natureCloudy: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M13 6a3 3 0 1 0 0-6a3 3 0 0 0 0 6M5 16a5 5 0 1 1 4.52-7.14A4 4 0 1 1 12 16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default natureCloudy
